import { Injectable, Inject } from '@angular/core';
import { BaseService } from './BaseService';
import { Observable, throwError, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { IOasisScan } from '../Models/IOasisScan ';


@Injectable()
export class OasisService extends BaseService {

  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) { super(_http); this._baseUrl = baseUrl}

  getOasisScansByStudent(localStudentId: string): Observable<IOasisScan[]> {
    return this._http.get<IOasisScan[]>(this._baseUrl + "api/Oasis/GetOasisScansByStudent" + localStudentId)
      .map((response: IOasisScan[]) => response as IOasisScan[])
      .catch(this.handleError);

  }

}